export default __webpack_public_path__ + "d160c83.png";